export default __webpack_public_path__ + "static/media/Spectral-BoldItalic.c4fbb3af.ttf";